export default __webpack_public_path__ + "21a0237f1c4382300d491d4d03583d93.png";